import { AbstractEditCommand } from "./AbstractEditCommand";

export class EditCommand<TSource, TState> extends AbstractEditCommand<TSource, TState> {
  constructor(private _backup: (s: TSource) => TState, private _execute: (s: TSource) => void, private _revert: (s: TSource, b: TState) => void) {
    super();
  }

  protected restructure(backup: (s: TSource) => TState, execute: (s: TSource) => void, revert: (s: TSource, b: TState) => void): void {
    this._backup = backup;
    this._execute = execute;
    this._revert = revert;
  }

  protected backup(source: TSource): TState {
    return this._backup(source);
  }

  protected execute(source: TSource): void {
    this._execute(source);
  }

  protected revert(source: TSource, backupped: TState): void {
    this._revert(source, backupped);
  }
}
